import Icon from '../../components/Icon.vue'

Icon.register({"regular/save":{"width":448,"height":512,"paths":[{"d":"M433.9 129.9L350.1 46.1A48-48 0 0 1 316.1 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V163.9A48-48 0 0 1 433.9 129.9zM272 80V160H144V80H272zM394 432H54A6-6 0 0 0 48 426V86A6-6 0 0 0 54 80H96V184C96 197.3 106.7 208 120 208H296C309.3 208 320 197.3 320 184V83.9L398.2 162.1A6-6 0 0 0 400 166.4V426A6-6 0 0 0 394 432zM224 232C175.5 232 136 271.5 136 320S175.5 408 224 408 312 368.5 312 320 272.5 232 224 232zM224 360C201.9 360 184 342.1 184 320S201.9 280 224 280 264 297.9 264 320 246.1 360 224 360z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/save.js
// module id = AOk0
// module chunks = 0